/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

import { Button } from '@carbon/react';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Invoker from '../utils/invoker';
import { getOauthErrorMessage } from '../utils/error-message-handler';

function TestToolRefreshToken({ config, onClick }) {
  const [authToken, setAuthToken] = useState({ access_token: '' });
  const [authError, setAuthError] = useState({});
  const invoker = useMemo(() => new Invoker(), []);
  const { t } = useTranslation();

  const refreshToken = async () => {
    const { identification } = config;
    const oauthRefreshUrl = config.flags.selectedRefreshUrl ? config.flags.selectedRefreshUrl : config.flags.selectedTokenUrl;
    const token = Object.assign(authToken);
    const error = {};
    try {
      const response = await invoker.refreshToken(oauthRefreshUrl, token, identification.clientID, identification.clientSecret);

      setAuthError(error);
      Object.keys(response).forEach((key) => {
        token[key] = response[key];
      });
    } catch (err) {
      console.error(err.stack);
      const error = await getOauthErrorMessage(err, t);
      setAuthError(error);
    } finally {
      setAuthToken(token);
      if (onClick && typeof onClick === 'function') {
        onClick({ authToken: token, authError: error });
      }
    }
  };

  return (
    <div className="refreshToken">
      <Button className="refreshTokenButton" id="refreshTokenButton" onClick={refreshToken}>
        {t('explorer_refresh_token')}
      </Button>
      {authError && authError.highlightedText && (
        <div className="authError">
          <pre>
            <code className="boundedSection hljs oauthError" dangerouslySetInnerHTML={authError.highlightedText} />
          </pre>
        </div>
      )}
    </div>
  );
}

export default TestToolRefreshToken;
